<ng-container [ngSwitch]="iconType">
    <i *ngSwitchCase="'matIcon'" class="material-icons">{{ matIcon }}</i>
    <div *ngSwitchCase="'logoUrl'" class="business-navbar__icon-container">
        <img class="business_navbar__icon__size" [src]="logoUrl">
    </div>
    <div *ngSwitchCase="'generated'" class="business-navbar__icon-container" [style.background-color]="getIconColorForName()">
        <span *ngIf="!!productName && !logoUrl">{{ getAbbreviationForName() }}</span>
    </div>
    <div *ngSwitchDefault class="business-navbar__icon__stencil"></div>
</ng-container>
